// src/authz/RequireCan.jsx
import React, { useContext, useRef } from "react";
import { Navigate } from "react-router-dom";
import ErrorPage from "../components/ErrorPage";
import { useCan } from "./useCan";
import { usePermissionsCtx } from "./PermissionsProvider";
// (optioneel) import Spinner from "../components/Spinner";
import { AuthContext } from "../AuthProvider";
import { useCanEnterStaffPortal } from "./staffPortalAccess";

export default function RequireCan({ resource, action, children }) {
  const { authenticated, kcReady, login } = useContext(AuthContext);
  const { ready } = usePermissionsCtx();         // ← wacht eerst
  const canThis      = useCan(resource, action);
  const canEnterStaffPortal = useCanEnterStaffPortal();
  const loginTriggeredRef = useRef(false);

  if (!kcReady) return null;

  if (!authenticated) {
    if (!loginTriggeredRef.current) {
      loginTriggeredRef.current = true;
      login();
    }
    return null;
  }

  // Wachten tot /authz/me binnen is
  if (!ready) return null; // of: <Spinner />

  // 1) Toegang: render
  if (canThis) return children;

  // 2) Geen staff? -> vriendelijk naar parent portal
  if (!canEnterStaffPortal) {
    return <Navigate to="/portal" replace />;
  }

  // 3) Wél staff maar mist dit specifieke recht → 403
  return <ErrorPage status={403} message="Geen toegang" />;
}
